import { render, staticRenderFns } from "./healthSaarthiIndex.vue?vue&type=template&id=6f932639"
import script from "./healthSaarthiIndex.vue?vue&type=script&lang=js"
export * from "./healthSaarthiIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports